module.exports = __webpack_public_path__ + "img/level_five.61995b41.png";